import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineAlertComponent } from './inline-alert.component';
import { SharedModule } from '../../helper/shared.module';
import { A11yLinkDirective } from '../../helper/directives';


@NgModule({
  declarations: [InlineAlertComponent],
  imports: [
    A11yLinkDirective,
    CommonModule,
    SharedModule
  ],
  exports: [InlineAlertComponent]
})
export class InlineAlertModule { }
